export default __webpack_public_path__ + "static/media/45g.2b2df0dc.svg";